import accounting from 'accounting'

/**
 * @param { string } lang
 * @param { string } currency        the currency destination
 * @param { object } settings
 */
class Currency {
  constructor(options, settings) {
    if (!options || !settings) {
      throw new Error('Missing parameters')
    }

    const { lang, currency } = options

    this.settings = Object.assign(this.settings, settings)

    const currencies = this.settings.currencies

    if (!currencies || !currencies[currency]) return

    this.lang = lang
    this.currency = currency

    this.render()
    this.afterRender()
  }

  settings = {
    langs: {
      fr: {
        template: 'symbolFirstFullSpace',
        decimal: ',',
        thousand: ' ',
      },
      en: {
        template: 'noSpace',
        decimal: '.',
        thousand: ',',
      },
      it: {
        template: 'symbolFirstFullSpace',
        decimal: ',',
        thousand: '.',
      },
      nl: {
        template: 'symbolFirstSpace',
        decimal: ',',
        thousand: '.',
      },
      de: {
        template: 'valueFirstFullSpace',
        decimal: ',',
        thousand: '.',
      },
      es: {
        template: 'valueFirstFullSpace',
        decimal: ',',
        thousand: '.',
      },
      ca: {
        template: 'valueFirstFullSpace',
        decimal: ',',
        thousand: '.',
      },
      pt: {
        template: 'noSpace',
        decimal: ',',
        thousand: '.',
      },
    },
  }

  templates = {
    //'%s %v %t' // FR
    symbolFirstFullSpace(val, currency, withTrigram, trigramPosition) {
      const { symbol, separator, trigram } = currency
      const html = `${this.settings.formatValue(val)} ${symbol} ${
        withTrigram && trigram ? this.settings.formatTrigram(trigram, separator) : ''
      }`

      return this.postTemplate(trigram, trigramPosition, html)
    },

    // template: '%s$t%v' // EN - IT
    noSpace(val, currency, withTrigram, trigramPosition) {
      const { symbol, separator, trigram } = currency
      const html = `${symbol}${
        withTrigram && trigram ? this.settings.formatTrigram(trigram, separator) : ''
      }${this.settings.formatValue(val)}`

      return this.postTemplate(trigram, trigramPosition, html)
    },

    // template: '%v %s %t' // DE - ES
    valueFirstFullSpace(val, currency, withTrigram, trigramPosition) {
      const { symbol, separator, trigram } = currency
      const html = `${this.settings.formatValue(val)} ${symbol}${
        withTrigram && trigram ? this.settings.formatTrigram(trigram, separator) : ''
      }`

      return this.postTemplate(trigram, trigramPosition, html)
    },

    // template: '%s %t%v' // NL
    symbolFirstSpace(val, currency, withTrigram, trigramPosition) {
      const { symbol, separator, trigram } = currency
      const html = `${symbol} ${this.settings.formatValue(val)}${
        withTrigram && trigram ? this.settings.formatTrigram(trigram, separator) : ''
      }`

      return this.postTemplate(trigram, trigramPosition, html)
    },
  }

  /**
   * @param { string } trigram
   * @param { string } trigramPosition
   * @param { any } html
   * @param { boolean } noSpace used for the special cases (it, nl, en, pt)
   * @returns
   */
  postTemplate(trigram, trigramPosition, html) {
    if (!trigram || !trigramPosition) return html

    // const reg = /(<[\w\s\S]+>)/;
    const reg = this.settings.regex
    const match = reg.exec(html)

    if (!match) return html

    html = html.replace(match[0], '')

    if ('after' == trigramPosition) {
      html = `${html} ${match[0]}`
    }

    if ('before' == trigramPosition) {
      html = `${match[0]} ${html}`
    }

    return html
  }

  /**
   * @param { number } amount
   * @param { string } baseCurrency
   * @returns
   */

  getConversion(amount = '', baseCurrency) {
    amount = amount.replace(/,/g, '.')

    if (baseCurrency == this.currency) return amount

    const rate = this.settings.rates[this.currency]
    //convert in baseCurrency
    const inBaseCurrency = amount / this.settings.rates[baseCurrency]
    //convert in currency
    return inBaseCurrency * rate
  }

  render() {
    const langOpts = this.settings.langs[this.lang] || this.settings.langs['en']
    const currencyInfos = this.settings.currencies[this.currency]
    const template = this.templates[langOpts.template].bind(this)

    this.settings = Object.assign(this.settings, accounting.settings.number, langOpts)

    const currencyNodes = Array.prototype.slice.call(document.querySelectorAll('.js-currency'))

    currencyNodes.forEach((node) => {
      const baseCurrency = node.getAttribute('data-currency')

      if (baseCurrency == this.currency) return
      const newCheckout = node.getAttribute('data-newcheckout')
      if (newCheckout) return
      const val = this.getConversion(node.getAttribute('data-value'), baseCurrency)
      const withTrigram = node.getAttribute('data-trigram')
      const trigramPosition = node.getAttribute('data-trigram-position')
      const precision = node.getAttribute('data-precision') || 0

      accounting.settings.number.precision = precision

      const result = template(accounting.formatNumber(val), currencyInfos, withTrigram, trigramPosition)

      node.innerHTML = result
    })
  }

  afterRender() {
    var event = new CustomEvent('currency:afterRender')
    window.dispatchEvent(event)
  }
}

export default Currency

window.Currency = Currency
